import "./Footer.css"
import { useEffect, useRef } from "react"
import { motion, useInView } from "framer-motion"

export const Footer = ({ abrirModal }) => {

    const footerRef = useRef(null)
    const logoArpadevRef = useRef(null)
    const menuNavegacaoRef = useRef(null)
    const isInView = useInView(logoArpadevRef, menuNavegacaoRef, { triggerOnce: true, threshold: 1 })

    useEffect(() => {
        if (footerRef.current) {
            if (abrirModal) {
                footerRef.current.style.filter = "blur(8px)"
                footerRef.current.style.pointerEvents = "none"
            } else {
                footerRef.current.style.filter = "none"
                footerRef.current.style.pointerEvents = "auto"
            }
        }
    }, [abrirModal])
    return (
        <footer className="container-footer" ref={footerRef}>
            <div className="logos">
                <motion.div
                    className="logo-arpa"
                    ref={logoArpadevRef}
                    initial={{ opacity: 0, x: 0 }}
                    animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <img src="../imagens/footer/logo-sti.png" alt="Logo da Secretaria de TI" />
                </motion.div>
            </div>
            <div className="background-menu-navegacao">
                <motion.nav 
                    className="menu-navegacao"
                    ref={menuNavegacaoRef}
                    initial={{ opacity: 0, x: 0 }}
                    animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}  
                >
                    <a
                        href="https://www.instagram.com/santacruzprefeitura"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                    <img src="../imagens/footer/social-media/icons8-instagram-24.png" alt="Logo do instagram" className="icones" />
                    </a>
                    {/* <img src="../imagens/footer/social-media/icons8-facebook-24.png" alt="Logo do facebook" className="icones" />
                    <img src="../imagens/footer/social-media/e-mail.png" alt="Logo do e-mail" className="icones" /> */}
                    <a
                        href="https://www.youtube.com/prefeiturasantacruzrn"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="YouTube"
                    >
                    <img src="../imagens/footer/social-media/icons8-reproduzir-youtube-24.png" alt="Logo do youtube" className="icones" />
                    </a>
                </motion.nav>
            </div>
        </footer>
    )
}
